import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

const Layout = () => {
  const token = localStorage.getItem('token');

  return (
    <div className="admin-layout" style={{ 
      display: 'flex', 
      minHeight: '100vh', 
      backgroundColor: '#0d0e10',
      width: '100%' 
    }}>
      {/* Token varsa Sidebar'ı göster */}
      {token && <Sidebar />}
      
      {/* İçerik Alanı */}
      <main className="admin-main-content" style={{ 
          flexGrow: 1, 
          minWidth: 0, 
          display: 'flex',
          flexDirection: 'column', // Tırnak içine aldık (Hata buradaydı)
          position: 'relative'
      }}>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;